import { Flags } from '@constants/flags';
import { useFlag } from '@onevesthq/feature-flags/web';

/**
 * Flagsmith gate for the V2 bulk rebalance page (`/rebalance`) and sidebar entry.
 */
export const useBulkRebalanceEnabled = (): boolean => {
  const { enabled } = useFlag(Flags.bulk_rebalance, {
    default: false,
  });
  return enabled;
};
